<template>
  <title>{{ title }}</title>
  <meta name="description" :content="description">
  <meta itemprop="name" :content="title">
  <meta itemprop="description" :content="description">
  <link rel="canonical" :href="url" />

  <meta name="twitter:card" property="twitter:card" content="summary_large_image">
  <meta name="twitter:title" property="twitter:title" :content="title">
  <meta name="twitter:description" property="twitter:description" :content="description">
  <meta name="twitter:image:src" property="twitter:image:src" :content="img1024x512">
  <meta name="twitter:site" property="twitter:site" content="@nslookupio">
  <meta name="twitter:creator" property="twitter:creator" content="@ruurtjan">

  <meta name="og:title" property="og:title" :content="title">
  <meta name="og:description" property="og:description" :content="description">
  <meta name="og:image" property="og:image" :content="img1200x630">
  <meta name="og:url" property="og:url" :content="url">
  <meta name="og:site_name" property="og:site_name" content="NsLookup.io">
  <template v-if="written">
    <meta name="og:type" property="og:type" content="article">
    <meta name="article:published_time" property="article:published_time" :content="written.toISOString()">
    <meta v-if="modified" name="article:modified_time" property="article:modified_time" :content="modified.toISOString()">
  </template>
  <meta v-else name="og:type" property="og:type" content="website">
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: true,
  },
  img1024x512: {
    type: String,
    default: 'https://www.nslookup.io/img/social-1024x512.png',
  },
  img1200x630: {
    type: String,
    default: 'https://www.nslookup.io/img/social-1200x630.png',
  },
  written: Date,
  modified: Date,
});
</script>
